export const DEFAULT_BLUR_IMAGE = '/blur-placeholder.png';
